import { Button, Flex, Link, Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { FC } from "react";

interface CriticalErrorMessageProps {
  onBackClick: () => void;
}

export const CriticalErrorMessage: FC<CriticalErrorMessageProps> = ({
  onBackClick,
}) => (
  <Stack gap="8">
    <Flex placeItems="center">
      <SvgInline name="error-dog" width="236" />
    </Flex>
    <Text align="center" textStyle="heading5" textStyle-sm="heading4">
      Oops, something went wrong
    </Text>
    <Text align="center">
      It looks like we’re having an unexpected problem and can’t process your
      request. Please try again or{" "}
      <Link href="/contact" newTab={false}>
        contact us
      </Link>{" "}
      so we can help.
    </Text>
    <Button width="100%" onClick={onBackClick}>
      Back
    </Button>
  </Stack>
);
